import { motion } from "framer-motion"

export default function BaseModalPage(props: { visible: boolean; children: React.ReactNode }) {
    return (
        <motion.div
            initial={{
                x: "100%",
            }}
            animate={{
                x: props.visible ? 0 : "100%",
            }}
            transition={{
                type: "ease",
            }}
            className="w-full h-full z-20 absolute top-0 left-0 bg-white pt-2 overflow-y-scroll pb-12 pl-2">
            {props.children}
        </motion.div>
    )
}
